/**
 * Resolve a path in public/ against the deployed base path.
 *
 * Hardcoding a leading "/" breaks any host that serves from a subpath, which
 * PLAN.md §6.5 flags as the most common cause of a blank page on a static host.
 */
export function asset(path: string): string {
  const base = import.meta.env.BASE_URL;
  return `${base.endsWith('/') ? base : `${base}/`}${path.replace(/^\//, '')}`;
}
